import React from 'react';
import { ChevronRight, Calendar, ClipboardList, TrendingUp, Clock, MapPin, Activity, User, ChevronDown, ArrowLeft } from 'lucide-react';
interface PackageDetailProps {
  onBack: () => void;
}
export function PackageDetail({
  onBack
}: PackageDetailProps) {
  const interventions = [{
    id: 1,
    address: 'Via Roma 4',
    type: 'Pulizia Standard',
    time: '10:00 - 12:00',
    host: 'Marco B.',
    price: '€50',
    top: '30%',
    left: '20%'
  }, {
    id: 2,
    address: 'Via Milano 12',
    type: 'Pulizia Standard',
    time: '12:30 - 14:00',
    host: 'Anna R.',
    price: '€45',
    top: '45%',
    left: '50%'
  }, {
    id: 3,
    address: 'Via Napoli 8',
    type: 'Pulizia Standard',
    time: '14:30 - 16:00',
    host: 'Luca T.',
    price: '€45',
    top: '60%',
    left: '35%'
  }];
  return <div className="space-y-6" data-id="element-1640">
      {/* Header Section */}
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4" data-id="element-1641">
        <div data-id="element-1642">
          <nav className="flex items-center gap-2 text-xs text-gray-500 mb-2" data-id="element-1643">
            <button onClick={onBack} className="hover:text-teal-deep transition-colors" data-id="element-1644">
              Opportunità
            </button>
            <ChevronRight size={12} data-id="element-1645" />
            <span className="text-navy font-medium" data-id="element-1646">Pacchetto Zona Prati</span>
          </nav>
          <h1 className="text-2xl font-bold font-montserrat text-navy mb-1" data-id="element-1647">
            Pacchetto Zona Prati
          </h1>
          <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-1648">
            <Calendar size={14} data-id="element-1649" />
            <span data-id="element-1650">6 Febbraio 2026</span>
          </div>
        </div>
        <button className="bg-teal-deep text-white px-6 py-2.5 rounded-lg font-medium text-sm hover:bg-teal-deep/90 transition-colors shadow-sm" data-id="element-1651">
          Accetta Pacchetto
        </button>
      </div>

      {/* Summary Stats Row */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1652">
        <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-1653">
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-1654">
            Interventi
          </div>
          <div className="flex items-center gap-2" data-id="element-1655">
            <ClipboardList className="text-gray-400 w-5 h-5" data-id="element-1656" />
            <span className="text-2xl font-bold text-navy" data-id="element-1657">3</span>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-1658">
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-1659">
            Guadagno Totale
          </div>
          <div className="flex items-center gap-2" data-id="element-1660">
            <TrendingUp className="text-green-600 w-5 h-5" data-id="element-1661" />
            <span className="text-2xl font-bold text-green-600" data-id="element-1662">€140</span>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-1663">
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-1664">
            Tempo Stimato
          </div>
          <div className="flex items-center gap-2" data-id="element-1665">
            <Clock className="text-gray-400 w-5 h-5" data-id="element-1666" />
            <span className="text-2xl font-bold text-navy" data-id="element-1667">
              3.5 <span className="text-sm font-normal text-gray-500" data-id="element-1668">ore</span>
            </span>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-4 relative overflow-hidden" data-id="element-1669">
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-1670">
            Punteggio Densità
          </div>
          <div className="flex items-center gap-2" data-id="element-1671">
            <Activity className="text-teal-deep w-5 h-5" data-id="element-1672" />
            <span className="text-2xl font-bold text-navy" data-id="element-1673">
              98<span className="text-sm font-normal text-gray-500" data-id="element-1674">/100</span>
            </span>
          </div>
          <div className="absolute bottom-0 left-0 w-full h-1 bg-gray-100" data-id="element-1675">
            <div className="h-full bg-teal-deep w-[98%]" data-id="element-1676"></div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6" data-id="element-1677">
        {/* Map Section */}
        <div className="lg:col-span-5 h-[400px] lg:h-auto bg-white border border-gray-200 rounded-xl overflow-hidden flex flex-col" data-id="element-1678">
          <div className="p-4 border-b border-gray-200 bg-white z-10" data-id="element-1679">
            <h3 className="text-navy font-semibold text-sm flex items-center gap-2" data-id="element-1680">
              <MapPin size={16} className="text-teal-deep" data-id="element-1681" />
              Mappa Percorso
            </h3>
          </div>
          <div className="relative flex-1 bg-gray-50 overflow-hidden" data-id="element-1682">
            {/* Grid Pattern Background */}
            <div className="absolute inset-0 opacity-[0.03]" style={{
            backgroundImage: 'linear-gradient(#1E365C 1px, transparent 1px), linear-gradient(90deg, #1E365C 1px, transparent 1px)',
            backgroundSize: '40px 40px'
          }} data-id="element-1683"></div>

            {/* Decorative Map Elements */}
            <svg className="absolute inset-0 w-full h-full pointer-events-none opacity-10" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-1684">
              <path d="M0,50 Q25,45 50,50 T100,45" fill="none" stroke="#1E365C" strokeWidth="2" data-id="element-1685" />
              <path d="M30,0 Q35,50 30,100" fill="none" stroke="#1E365C" strokeWidth="1" data-id="element-1686" />
              <path d="M70,0 Q65,50 70,100" fill="none" stroke="#1E365C" strokeWidth="1" data-id="element-1687" />
            </svg>

            {/* Route Line */}
            <svg className="absolute inset-0 w-full h-full pointer-events-none z-0" style={{
            overflow: 'visible'
          }} data-id="element-1688">
              <path d="M20,30 L50,45 L35,60" fill="none" stroke="#2E8C7E" strokeWidth="2" strokeDasharray="4 4" className="opacity-50" data-id="element-1689" />
            </svg>

            {/* Pins */}
            {interventions.map(item => <div key={item.id} className="absolute transform -translate-x-1/2 -translate-y-1/2 group cursor-pointer" style={{
            top: item.top,
            left: item.left
          }} data-id="element-1690">
                <div className="w-8 h-8 rounded-full bg-teal-deep text-white font-bold flex items-center justify-center shadow-lg ring-4 ring-teal-100 z-10 relative transition-transform hover:scale-110" data-id="element-1691">
                  {item.id}
                </div>
                <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 bg-navy text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-20" data-id="element-1692">
                  {item.address}
                </div>
              </div>)}
          </div>
          <div className="p-3 bg-white border-t border-gray-200 text-xs text-gray-500 flex justify-between" data-id="element-1693">
            <span data-id="element-1694">
              Distanza totale: <strong data-id="element-1695">1.2 km</strong>
            </span>
            <span data-id="element-1696">
              Tempo spostamenti: <strong data-id="element-1697">15 min</strong>
            </span>
          </div>
        </div>

        {/* Interventions List & Assignment */}
        <div className="lg:col-span-7 space-y-6" data-id="element-1698">
          <div className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-1699">
            <div className="p-4 border-b border-gray-200 bg-gray-50/50" data-id="element-1700">
              <h3 className="font-semibold text-navy text-sm" data-id="element-1701">
                Lista Interventi
              </h3>
            </div>
            <div className="divide-y divide-gray-100" data-id="element-1702">
              {interventions.map(item => <div key={item.id} className="p-4 hover:bg-gray-50 transition-colors" data-id="element-1703">
                  <div className="flex justify-between items-start mb-2" data-id="element-1704">
                    <div className="flex items-center gap-3" data-id="element-1705">
                      <div className="w-6 h-6 rounded-full bg-teal-100 text-teal-deep font-bold text-xs flex items-center justify-center" data-id="element-1706">
                        {item.id}
                      </div>
                      <h4 className="font-bold text-navy text-sm" data-id="element-1707">
                        {item.address}
                      </h4>
                    </div>
                    <span className="font-bold text-navy" data-id="element-1708">{item.price}</span>
                  </div>
                  <div className="pl-9 grid grid-cols-2 gap-y-2 text-xs text-gray-600" data-id="element-1709">
                    <div className="flex items-center gap-2" data-id="element-1710">
                      <span className="text-gray-400" data-id="element-1711">Tipo:</span>
                      <span className="font-medium" data-id="element-1712">{item.type}</span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-1713">
                      <span className="text-gray-400" data-id="element-1714">Host:</span>
                      <span className="font-medium" data-id="element-1715">{item.host}</span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-1716">
                      <span className="text-gray-400" data-id="element-1717">Orario:</span>
                      <span className="font-medium bg-gray-100 px-1.5 py-0.5 rounded text-navy" data-id="element-1718">
                        {item.time}
                      </span>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Assignment Section */}
          <div className="bg-white border border-gray-200 rounded-xl p-5" data-id="element-1719">
            <label className="block text-sm font-semibold text-navy mb-3" data-id="element-1720">
              Assegna a:
            </label>
            <div className="relative" data-id="element-1721">
              <div className="w-full border border-gray-200 rounded-lg px-3 py-2.5 flex items-center justify-between cursor-pointer hover:border-teal-deep transition-colors bg-white" data-id="element-1722">
                <div className="flex items-center gap-2" data-id="element-1723">
                  <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center" data-id="element-1724">
                    <User size={14} className="text-gray-500" data-id="element-1725" />
                  </div>
                  <span className="text-sm text-gray-600" data-id="element-1726">
                    Seleziona membro del team...
                  </span>
                </div>
                <ChevronDown size={16} className="text-gray-400" data-id="element-1727" />
              </div>

              {/* Mock Dropdown Content (Hidden by default in static view, but structure implies functionality) */}
            </div>
            <p className="text-xs text-gray-400 mt-2 flex items-center gap-1" data-id="element-1728">
              <Activity size={12} data-id="element-1729" />
              Puoi assegnare anche dopo aver accettato il pacchetto.
            </p>
          </div>
        </div>
      </div>

      {/* Footer Actions */}
      <div className="border-t border-gray-200 pt-6 mt-8 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1730">
        <button onClick={onBack} className="text-sm text-gray-500 hover:text-navy flex items-center gap-2 transition-colors" data-id="element-1731">
          <ArrowLeft size={16} data-id="element-1732" />
          Torna alle Opportunità
        </button>
        <div className="flex items-center gap-4 w-full sm:w-auto" data-id="element-1733">
          <button className="text-sm font-medium text-teal-deep hover:text-teal-700 transition-colors whitespace-nowrap" data-id="element-1734">
            Accetta Singoli Interventi
          </button>
          <button className="bg-teal-deep text-white px-6 py-2.5 rounded-lg font-medium text-sm hover:bg-teal-deep/90 transition-colors shadow-sm w-full sm:w-auto" data-id="element-1735">
            Accetta Pacchetto
          </button>
        </div>
      </div>
    </div>;
}